module.exports = __webpack_public_path__ + "static/img/8bg_2.ffea34f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_2.png
// module id = 762
// module chunks = 1